export default __webpack_public_path__ + "0f6cb2ac751db16d6ff52163c0c9c012.png";